/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillingProductPriceTiersInner
 */
export interface BillingProductPriceTiersInner {
    /**
     * 
     * @type {number}
     * @memberof BillingProductPriceTiersInner
     */
    quantityStart: number;
    /**
     * When null, the tier is for all quantities above the start quantity.
     * @type {number}
     * @memberof BillingProductPriceTiersInner
     */
    quantityEnd: number | null;
    /**
     * 
     * @type {number}
     * @memberof BillingProductPriceTiersInner
     */
    unitPrice: number;
}

/**
 * Check if a given object implements the BillingProductPriceTiersInner interface.
 */
export function instanceOfBillingProductPriceTiersInner(value: object): value is BillingProductPriceTiersInner {
    if (!('quantityStart' in value) || value['quantityStart'] === undefined) return false;
    if (!('quantityEnd' in value) || value['quantityEnd'] === undefined) return false;
    if (!('unitPrice' in value) || value['unitPrice'] === undefined) return false;
    return true;
}

export function BillingProductPriceTiersInnerFromJSON(json: any): BillingProductPriceTiersInner {
    return BillingProductPriceTiersInnerFromJSONTyped(json, false);
}

export function BillingProductPriceTiersInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingProductPriceTiersInner {
    if (json == null) {
        return json;
    }
    return {
        
        'quantityStart': json['quantityStart'],
        'quantityEnd': json['quantityEnd'],
        'unitPrice': json['unitPrice'],
    };
}

  export function BillingProductPriceTiersInnerToJSON(json: any): BillingProductPriceTiersInner {
      return BillingProductPriceTiersInnerToJSONTyped(json, false);
  }

  export function BillingProductPriceTiersInnerToJSONTyped(value?: BillingProductPriceTiersInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'quantityStart': value['quantityStart'],
        'quantityEnd': value['quantityEnd'],
        'unitPrice': value['unitPrice'],
    };
}

